import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { ProductsAdmin } from './ProductsAdmin';
import { OrdersAdmin } from './OrdersAdmin';
import { CustomersAdmin, CouponsAdmin, SettingsAdmin, ReportsAdmin, QuotesAdmin, MediaAdmin } from './OtherAdmin';

export const SA = `${process.env.REACT_APP_BACKEND_URL}/api/admin/shop`;
export const authH = (json = true) => ({ Authorization: `Bearer ${localStorage.getItem('admin_token')}`, ...(json ? { 'Content-Type': 'application/json' } : {}) });
export const api = async (path, opts = {}) => {
  const r = await fetch(`${SA}${path}`, { ...opts, headers: { ...authH(!(opts.body instanceof FormData)), ...(opts.headers || {}) } });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(typeof d.detail === 'string' ? d.detail : `Error ${r.status}`);
  return d;
};
export const download = async (path, name) => {
  const r = await fetch(`${SA}${path}`, { headers: authH(false) });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(await r.blob());
  a.download = name;
  a.click();
};

const TABS = [
  ['products', 'Products & stock', ProductsAdmin], ['orders', 'Orders', OrdersAdmin], ['customers', 'Customers', CustomersAdmin],
  ['coupons', 'Coupons', CouponsAdmin], ['reports', 'Reports', ReportsAdmin], ['quotes', 'Bulk quotes', QuotesAdmin],
  ['media', 'Media library', MediaAdmin], ['settings', 'Settings, banners & staff', SettingsAdmin],
];
const ROLE_TABS = { fulfilment: ['orders'], content_editor: ['products', 'media', 'settings'], store_manager: TABS.map((x) => x[0]).filter((x) => x !== 'settings').concat('settings') };

const roleFromToken = () => {
  try { return JSON.parse(atob(localStorage.getItem('admin_token').split('.')[1])).role; } catch { return null; }
};

export default function AdminShop() {
  const navigate = useNavigate();
  const role = roleFromToken();
  const allowed = ROLE_TABS[role] || TABS.map((x) => x[0]);
  const [tab, setTab] = useState(allowed[0]);
  if (!localStorage.getItem('admin_token')) { navigate('/admin/login'); return null; }
  const Comp = TABS.find((x) => x[0] === tab)[2];
  return (
    <div className="min-h-screen bg-gray-100" data-testid="admin-shop-page">
      <header className="bg-white shadow-sm">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3 px-4 py-4">
          <Button variant="ghost" onClick={() => navigate('/admin/dashboard')} data-testid="admin-shop-back"><ArrowLeft className="mr-2 h-4 w-4" /> Dashboard</Button>
          <h1 className="text-2xl font-bold">Shop</h1>
          {role && <span className="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-600">role: {role}</span>}
        </div>
        <nav className="mx-auto flex max-w-7xl gap-1 overflow-x-auto px-4">
          {TABS.filter((x) => allowed.includes(x[0])).map(([id, label]) => (
            <button key={id} onClick={() => setTab(id)} className={`whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium ${tab === id ? 'border-[#E31E24] text-[#E31E24]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-testid={`shop-tab-${id}`}>{label}</button>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6"><Comp role={role} /></main>
    </div>
  );
}
